import React, { useState } from "react";
import one from "./../pics/theplace.jpg";
import two from "./../pics/theplace1.jpg";
import three from "./../pics/theplace3.jpg";
import four from "./../pics/theplace4.jpg";
import fur from "./../pics/theplace4o.jpg";
import five from "./../pics/theplace5.jpg";
import six from "./../pics/theplace6.jpg";
import seven from "./../pics/2777.jpg";
import eight from "./../pics/theplace8.jpg";
import nine from "./../pics/theplace9.jpg";
import purple from "./../pics/theplace7.jpg";
import purple2 from "./../pics/theplace7o.jpg";
import styles from "./styles.module.css";
import Carousel from "react-bootstrap/Carousel";
import "bootstrap/dist/css/bootstrap.min.css";

export const PlacePhotos = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="homerediv">
      <Carousel fade activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img className={styles.gallery} src={two} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={seven} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={five} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={eight} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={four} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={purple} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={three} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={nine} alt="" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};

export const PlacePhotosMobile = () => {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  return (
    <div className="homerediv">
      <Carousel fade activeIndex={index} onSelect={handleSelect}>
        <Carousel.Item>
          <img className={styles.gallery} src={one} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={purple2} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={three} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={six} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={fur} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={five} alt="" />
        </Carousel.Item>
        <Carousel.Item>
          <img className={styles.gallery} src={nine} alt="" />
        </Carousel.Item>
      </Carousel>
    </div>
  );
};
